import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { GN } from '../../../gn';
import { OutputDecorator } from '@angular/core/src/metadata/directives';
import { DIC } from '../../dic';

import * as moment from 'moment';


import { RepmapPage } from '../repmap/repmap';

/**
 * Generated class for the KokpitPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kokpit',
  templateUrl: 'kokpit.html',
})
export class KokpitPage {
  loadingData: boolean = true
  priv: boolean = false
  startDate: any
  endDate: any
  vehicles = []
  reportType: any
  DataPOIVisits = []
  DataPOIDuration = []
  DataSpentFuel = []
  DataSpentFuelMax = 0
  DataAddedFuel = []
  DataAddedFuelMax = 0
  DataKM = []
  DataMAXSPEED = []
  DataSpeedOver = []
  DataTaxi1 = []
  DataTaxi2 = []
  DataKMmax = 0
  DataSeddmax = 0
  HaveWorkTime = 0

  maxTaxi1 = 0
  maxTaxi2 = 0

  DataActivity = []
  period = ''
  period1 = ''
  momentalenDatum: any


  textFile: any = null
  link: any
  _onlyactveh = false;
  _ksource = false;


  // xls:any
  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {
    this._ksource = navParams.get('ksource') == undefined ? false : navParams.get('ksource')
    this.gn.globalreportButtons = true
    this._onlyactveh = navParams.get('onlyactveh') == undefined ? false : navParams.get('onlyactveh');
    this.startDate = navParams.get('sd')
    this.endDate = navParams.get('ed')
    this.vehicles = navParams.get('v')
    this.reportType = navParams.get('t')
    this.gn.xlsFunction = null
    this.gn.txtFunction = null
    this.period = moment(this.startDate).format('DD-MM-YYYY 00:00:00') + ' - ' + moment(this.endDate).format('DD-MM-YYYY 23:59:59');
    this.period1 = moment(this.startDate).format('DD-MM-YYYY') + ' - ' + moment(this.endDate).format('DD-MM-YYYY');
    this.momentalenDatum = moment(this.momentalenDatum).format(this.gn.user.DFormat) + ' ' + moment(this.momentalenDatum).format(this.gn.user.TFormat)

    // this.xls = navParams.get('xls')
  }


  ionViewDidLoad() {
    console.log('# BEFORE #')
    if (!this._ksource) {
      return false;
    }
    console.log('# AFTER #');

    if (this.startDate != null) {
      this.loadData()
    }
  }

  sec2str(_sec) {
    return moment.utc(_sec * 1000).format('HH:mm:ss');
  }
  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  loadData() {
    this.gn.globalreportButtons = true
    var logvozila = ' за сите возила';
    var logperiod = 'Период од: ' + moment(this.startDate).format('DD-MM-YYYY 00:00:00') + ' до: ' + moment(this.endDate).format('DD-MM-YYYY 23:59:59');
    this.gn.addLog(10, logperiod + logvozila);

    // console.log(this.startDate, this.endDate, this.vehicles, this.reportType)
    this.loadingData = true
    this.priv = this.gn.getPriv('dashboard')


    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      rid: this.gn.crypt(this.gn.user.RoleId),
      sd: this.gn.crypt(this.startDate),
      ed: this.gn.crypt(this.endDate),
      hasfuel: this.gn.crypt(parseInt(this.gn.clientsettings.hasfuelint + '')),
      showstayfuel: this.gn.crypt(this.gn.clientsettings.showstayfuel)
    }

    var _that = this
    this.gn._Post('/api/gn/reports/overview', _dat, function (_data) {
      _that.DataPOIVisits = _data.poiVisits
      _that.DataPOIDuration = _data.poiDuration
      _that.DataSpentFuel = _data.spentfueldata
      _that.DataAddedFuel = _data.addedfueldata


      if (_data.km.length > 0) {
        if (_data.km[0].km == null) {
          _that.HaveWorkTime = 1
        } else {
          _that.HaveWorkTime = 0
        }
      }

      for (var i = 0; i < _data.km.length; i++) {

        if (_that.HaveWorkTime == 0) {
          _data.km[i].km = parseInt(_data.km[i].km)
          if (_data.km[i].km > _that.DataKMmax) {
            _that.DataKMmax = _data.km[i].km
          }
        } else {
          _data.km[i].kmin = parseInt(_data.km[i].kmin)
          _data.km[i].kmafter = parseInt(_data.km[i].kmafter)
          if (_data.km[i].kmin + _data.km[i].kmafter > _that.DataKMmax) {
            _that.DataKMmax = _data.km[i].kmin + _data.km[i].kmafter
          }
        }

      }
      if (_that.DataKMmax == 0) {
        _that.DataKMmax = 100
      }
      for (var i = 0; i < _data.act.length; i++) {
        _data.act[i].total = _data.act[i].stay + _data.act[i].motoroff + _data.act[i].motoron + _data.act[i].parked
        if (_data.act[i].total == 0) { _data.act[i].total = 1 }
        for (var j = 0; j < _data.km.length; j++) {
          if (_data.act[i].vehid == _data.km[j].vehid) {
            _data.act[i].code = _data.km[j].code
            _data.act[i].registration = _data.km[j].registration
            _data.act[i].alias = _data.km[j].alias
          }
        }
      }
      for (var i = 0; i < _data.mspeed.length; i++) {
        _data.mspeed[i].speed = parseInt(_data.mspeed[i].speed)
        if (_data.mspeed[i].speed > _that.DataSeddmax) {
          _that.DataSeddmax = _data.mspeed[i].speed
        }
      }
      for (var i = 0; i < _data.spentfueldata.length; i++) {
        _data.spentfueldata[i].spentfuel = parseFloat(_data.spentfueldata[i].spentfuel)
        if (_data.spentfueldata[i].spentfuel > _that.DataSpentFuelMax) {
          _that.DataSpentFuelMax = _data.spentfueldata[i].spentfuel
        }
      }
      for (var i = 0; i < _data.addedfueldata.length; i++) {
        _data.addedfueldata[i].addedfuel = parseFloat(_data.addedfueldata[i].addedfuel)
        if (_data.addedfueldata[i].addedfuel > _that.DataAddedFuelMax) {
          _that.DataAddedFuelMax = _data.addedfueldata[i].addedfuel
        }
      }

      for (var i = 0; i < _data.speedover.length; i++) {
        _data.speedover[i].over60 = parseInt(_data.speedover[i].over60)
        _data.speedover[i].over80 = parseInt(_data.speedover[i].over80)
        _data.speedover[i].over100 = parseInt(_data.speedover[i].over100)
        _data.speedover[i].over120 = parseInt(_data.speedover[i].over120)
        _data.speedover[i].total = _data.speedover[i].over60 + _data.speedover[i].over80 + _data.speedover[i].over100 + _data.speedover[i].over120
        if (_data.speedover[i].total == 0) { _data.speedover[i].total = 1 }
        for (var j = 0; j < _data.km.length; j++) {
          if (_data.speedover[i].vehicleid == _data.km[j].vehid) {
            _data.speedover[i].code = _data.km[j].code
            _data.speedover[i].registration = _data.km[j].registration
            _data.speedover[i].alias = _data.km[j].alias
          }
        }
        // console.log(_data.speedover[i].over60,_data.speedover[i].over80,_data.speedover[i].over100,_data.speedover[i].over120, _data.speedover[i].total)
      }
      _that.DataKM = _data.km
      _that.DataActivity = _data.act
      _that.DataMAXSPEED = _data.mspeed
      _that.DataSpeedOver = _data.speedover
      // console.log(_data.speedover)
      // console.log(_data.km)
      if (_that.gn.clientsettings.clienttypeid == 2) {
        for (var i = 0; i < _data.taxi1.length; i++) {
          if (_data.taxi1[i].notours > _that.maxTaxi1) {
            _that.maxTaxi1 = _data.taxi1[i].notours
          }
        }
        for (var i = 0; i < _data.taxi2.length; i++) {
          if (_data.taxi2[i].pricetaximeter == null) { _data.taxi2[i].pricetaximeter = 0 }
          if (_data.taxi2[i].pricetaximeter > _that.maxTaxi2) {
            _that.maxTaxi2 = _data.taxi2[i].pricetaximeter
          }
        }
        _that.DataTaxi1 = _data.taxi1
        _that.DataTaxi2 = _data.taxi2
        // console.log(_data.taxi1)
        // console.log(_data.taxi2)
      }

      _that.loadingData = false
      // console.log(_that.DataMAXSPEED)
      _that.gn.xlsFunction = function () {
        _that.createXLS()
      }
      _that.gn.txtFunction = function () {
        _that.createTXT()
      }
      _that.gn.globalreportButtons = false
    })
  }

  openMaxSpeedWindow(_vid, _code, _reg) {
    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      rid: this.gn.crypt(this.gn.user.RoleId),
      sd: this.gn.crypt(this.startDate),
      ed: this.gn.crypt(this.endDate),
      vid: this.gn.crypt(_vid)
    }
    var _that = this
    this.gn._Post('/api/gn/reports/maxspeeddata', _dat, function (_data) {
      console.log(_data[0])
      _data[0].code = _code
      _data[0].reg = _reg
      let modal = _that.modalCtrl.create(RepmapPage, _data[0]);
      modal.present();

    })
  }

  Round(_txt) {
    return parseInt(_txt + '')
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  //*********** XLS ***************/

  createTXT() {
    var _data1 = ''
    for (var i = 0; i < this.DataKM.length; i++) {
      var k = this.DataKM[i]
      var _km = k.km
      if (_km == null) {
        _km = k.kmin + k.kmafter
      }
      if (k.km != null) {
        _data1 += ([k.code, k.registration + ' ' + k.alias, this.RoundFloat(_km * this.gn.user.metricvalue) + ' ' + this.gn.user.metric])
      } else {
        _data1 += ([k.code, k.registration + ' ' + k.alias, this.RoundFloat(k.kmin * this.gn.user.metricvalue) + ' ' + this.gn.user.metric, this.RoundFloat(k.kmafter * this.gn.user.metricvalue) + ' ' + this.gn.user.metric])
      }
    }
    this.gn.prepareTXT(_data1, this.dic.l['overview'])
  }

  createXLS() {
    var _data1 = []

    for (var i = 0; i < this.DataKM.length; i++) {
      var k = this.DataKM[i]
      // console.log((k.kmin+k.kmafter), this.gn.user.metricvalue)
      var _km = k.km
      if (_km == null) {
        _km = k.kmin + k.kmafter
      }
      if (!this._onlyactveh || this._onlyactveh && ((this.DataActivity[i].drive != 0 || this.DataActivity[i].stay != 0 || this.DataActivity[i].motoroff != 0) && (this.DataKM[i].km != 0 || this.DataKM[i].kmin != 0 || this.DataKM[i].kmafter != 0))) {
        if (k.km != null) {
          _data1.push([k.code, k.registration + ' ' + k.alias, this.RoundFloat(_km * this.gn.user.metricvalue) + ' ' + this.gn.user.metric])
        } else {
          _data1.push([k.code, k.registration + ' ' + k.alias, this.RoundFloat(k.kmin * this.gn.user.metricvalue) + ' ' + this.gn.user.metric, this.RoundFloat(k.kmafter * this.gn.user.metricvalue) + ' ' + this.gn.user.metric])
        }
      }
      // _data1.push([k.code, k.registration + ' ' + k.alias, this.RoundFloat(_km*this.gn.user.metricvalue)+' '+this.gn.user.metric])
    }
    var _data2 = []
    for (var i = 0; i < this.DataActivity.length; i++) {
      var k = this.DataActivity[i]
      if (!this._onlyactveh || this._onlyactveh && ((this.DataActivity[i].drive != 0 || this.DataActivity[i].stay != 0 || this.DataActivity[i].motoroff != 0) && (this.DataKM[i].km != 0 || this.DataKM[i].kmin != 0 || this.DataKM[i].kmafter != 0))) {
        _data2.push([k.code, k.registration + ' ' + k.alias, this.sec2str2(k.drive), this.sec2str2(k.stay), this.sec2str2(k.motoroff), this.sec2str2(k.parked)])
      }
    }
    var _data3 = []
    for (var i = 0; i < this.DataMAXSPEED.length; i++) {
      var k = this.DataMAXSPEED[i]
      _data3.push([k.code, k.registration + ' ' + k.alias, this.RoundFloatCeil(k.speed * this.gn.user.metricvalue) + ' ' + this.gn.user.metricspeed])
    }
    var _data4 = []
    for (var i = 0; i < this.DataSpeedOver.length; i++) {
      var k = this.DataSpeedOver[i]
      _data4.push([k.code, k.registration + ' ' + k.alias, k.over60, k.over80, k.over100, k.over120])
    }
    var _data5 = []
    for (var i = 0; i < this.DataPOIVisits.length; i++) {
      var p = this.DataPOIVisits[i]
      _data5.push([i + 1, p.pinpoint, p.cnt])
    }
    var _data6 = []
    for (var i = 0; i < this.DataPOIDuration.length; i++) {
      var p = this.DataPOIDuration[i]
      _data6.push([i + 1, p.pinpoint, this.sec2str(p.cnt)])
    }

    var tabela1

    if (k.km != null) {
      tabela1 = {
        Title: this.dic.l["DistanceTraveled"],
        Cols: [
          { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
          { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
          { text: this.dic.l["DistanceTraveled"], type: 'n', width: 15, align: 'right' },
        ],
        Data: _data1
      }
    } else {
      tabela1 = {
        Title: this.dic.l["DistanceTraveled"],
        Cols: [
          { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
          { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
          { text: this.dic.l["DurWork"], type: 'n', width: 15, align: 'right' },
          { text: this.dic.l["BeyWork"], type: 'n', width: 15, align: 'right' },
        ],
        Data: _data1
      }
    }
    var xlsJsoon = {
      Sheets: [
        {
          Title: this.dic.l["overview"],
          SubTitle: '',
          SubTitles: [
            this.dic.l["Client"] + ': ' + this.gn.user.ClientName,
            this.dic.l["user"] + ': ' + this.gn.user.UserFullName,
            this.dic.l["Daterange"] + ': ' + moment(this.startDate).format(this.gn.user.DFormat) + ' - ' + moment(this.endDate).format(this.gn.user.DFormat),
            this.dic.l["vehicles"] + ': ' + this.dic.l["allvehicles"],
            this.dic.l["Datetime"] + ': ' + moment().format(this.gn.user.DFormat) + ' ' + moment().format(this.gn.user.TFormat)
          ],
          tables: [
            // { 
            //   Title: this.dic.l["DistanceTraveled"], 
            //   Cols:[
            //     {text: this.dic.l["code"], type: 'n', width:10, align: 'center'},
            //     {text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left'},
            //     {text: this.dic.l["DistanceTraveled"], type: 'n', width: 15, align: 'right'},            
            //   ],
            //   Data:_data1
            // },
            tabela1,
            {
              Title: this.dic.l["Activity"],
              Cols: [
                { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
                { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
                { text: this.dic.l["Driving"], type: 'n', width: 15, align: 'center' },
                { text: this.dic.l["Idle"], type: 'n', width: 15, align: 'center' },
                { text: this.dic.l["EngineOFF"], type: 'n', width: 15, align: 'center' },
                { text: this.dic.l["Parked"], type: 'n', width: 15, align: 'center' },
              ],
              Data: _data2
            },
            {
              Title: this.dic.l["MaxSpeed"],
              Cols: [
                { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
                { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
                { text: this.dic.l["MaxSpeed"], type: 'n', width: 15, align: 'center' },
              ],
              Data: _data3
            },
            {
              Title: this.dic.l["SpeedLimitExcess"],
              Cols: [
                { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
                { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
                { text: this.RoundFloatCeil(60 * this.gn.user.metricvalue), type: 'n', width: 15, align: 'center' },
                { text: this.RoundFloatCeil(80 * this.gn.user.metricvalue), type: 'n', width: 15, align: 'center' },
                { text: this.RoundFloatCeil(100 * this.gn.user.metricvalue), type: 'n', width: 15, align: 'center' },
                { text: this.RoundFloatCeil(120 * this.gn.user.metricvalue), type: 'n', width: 15, align: 'center' },
              ],
              Data: _data4
            },
            {
              Title: this.dic.l["PoiAccordingVisit"],
              Cols: [
                { text: '#', type: 'n', width: 10, align: 'center' },
                { text: this.dic.l["poi"], type: 't', width: 40, align: 'left' },
                { text: this.dic.l["VisitsCount"], type: 'n', width: 15, align: 'center' }
              ],
              Data: _data5
            },
            {
              Title: this.dic.l["PoiAccordingDur"],
              Cols: [
                { text: '#', type: 'n', width: 10, align: 'center' },
                { text: this.dic.l["poi"], type: 't', width: 40, align: 'left' },
                { text: this.dic.l["Duration"], type: 'n', width: 15, align: 'center' }
              ],
              Data: _data6
            },

          ]
        }
      ]

    }


    if (this.gn.clientsettings.clienttypeid == 2) {
      var _dataA = []
      for (var i = 0; i < this.DataTaxi1.length; i++) {
        var k = this.DataTaxi1[i]
        _dataA.push([k.code, k.registration + ' ' + k.alias, k.notours, this.sec2str(k.tourtime)])
      }
      var _dataB = []
      for (var i = 0; i < this.DataTaxi2.length; i++) {
        var k = this.DataTaxi2[i]
        _dataB.push([k.code, k.registration + ' ' + k.alias, k.pricetaximeter + ' MKD.'])
      }
      var tbl1 = {
        Title: this.dic.l["Tours"],
        Cols: [
          { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
          { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
          { text: this.dic.l["ToursCount"], type: 'n', width: 15, align: 'center' },
          { text: this.dic.l["Time"], type: 'n', width: 15, align: 'center' }
        ],
        Data: _dataA
      }

      var tbl2 = {
        Title: this.dic.l["WithTaximeter"],
        Cols: [
          { text: this.dic.l["code"], type: 'n', width: 10, align: 'center' },
          { text: this.dic.l["vehicle"], type: 't', width: 40, align: 'left' },
          { text: this.dic.l["WithTaximeter"], type: 'n', width: 15, align: 'right' },
        ],
        Data: _dataB
      }
      xlsJsoon.Sheets[0].tables.push(tbl1)
      xlsJsoon.Sheets[0].tables.push(tbl2)
    }
    // console.log(xlsJsoon)
    this.gn.prepareXLS(xlsJsoon, this.dic.l["overview"])

  }
}






// WEBPACK FOOTER //
// ./src/pages/reports/kokpit/kokpit.ts